<template lang="pug">
#editar-contrato-originacao
    BaseHeader(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.titulo")',
        :voltarPara='true',
        :exibeBotao='false'
    )

    .view-container
        section.editar-contrato-originacao__body
            .editar-contrato-originacao__card
                h1 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtitulo') }}
                el-card(
                    :body-style='{ padding: "20px" }',
                    shadow='never',
                    v-loading='carregando'
                )
                    el-form.col-12(
                        label-position='top',
                        :model='formEdicaoContrato',
                        :rules='formEdicaoContratoRegras',
                        ref='formEdicaoContratoRef'
                    )
                        .row-4
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.numeroContrato")',
                                prop='numeroContrato'
                            )
                                el-input#numeroContrato(
                                    disabled,
                                    v-model.number='formEdicaoContrato.numeroContrato',
                                    :placeholder='$t("mensagens.comuns.placeholder")',
                                    maxlength='10'
                                )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.corredor")',
                                prop='corredor'
                            )
                                el-select#corredor(
                                    v-model='formEdicaoContrato.corredor',
                                    v-loading='carregandoFornecedores',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='fornecedor in fornecedores',
                                        :id='fornecedor.id',
                                        :key='fornecedor.id',
                                        :label='fornecedor.nome',
                                        :value='fornecedor.id'
                                    )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.sucursal")',
                                prop='sucursal'
                            )
                                el-select#sucursal(
                                    v-model='formEdicaoContrato.sucursal',
                                    v-loading='carregandoSucursais',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    :disabled='sucursalBloqueadaPorDistribuicao',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='sucursal in sucursais',
                                        :key='sucursal.id',
                                        :label='sucursal.label',
                                        :value='sucursal.id'
                                    )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.vendedor")',
                                prop='vendedor'
                            )
                                el-input#vendedor(
                                    v-model='formEdicaoContrato.vendedor',
                                    :placeholder='$t("mensagens.comuns.placeholder")'
                                )
                        .row-4
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.produto")',
                                prop='cultura'
                            )
                                el-select#cultura(
                                    v-model='formEdicaoContrato.cultura',
                                    v-loading='carregandoCulturas',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='cultura in culturas',
                                        :key='cultura.id',
                                        :label='cultura.nome',
                                        :value='cultura.id'
                                    )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.anoAfip")',
                                prop='anoAfip'
                            )
                                el-select#anoAfip(
                                    v-model='formEdicaoContrato.anoAfip',
                                    v-loading='carregandoSafras',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='safra in safras',
                                        :key='safra.id',
                                        :label='safra.ano',
                                        :value='safra.id'
                                    )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataContrato")',
                                prop='dataContrato'
                            )
                                el-date-picker#dataContrato(
                                    v-model='formEdicaoContrato.dataContrato',
                                    type='date',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    format='dd/MM/yyyy'
                                )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataEntrega")',
                                prop='dataEntrega'
                            )
                                el-date-picker#dataEntrega(
                                    v-model='formEdicaoContrato.dataEntrega',
                                    type='date',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    format='dd/MM/yyyy'
                                )
                        .row-3
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.cuitVendedor")',
                                prop='cuitVendedor'
                            )
                                el-input#cuitVendedor(
                                    v-model='formEdicaoContrato.cuitVendedor',
                                    v-mask='["##-########-#"]',
                                    :placeholder='$t("mensagens.comuns.placeholder")'
                                )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.condicaoClienteLabel")',
                                prop='condicaoCliente'
                            )
                                el-select#condicaoCliente(
                                    v-model='formEdicaoContrato.condicaoCliente',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='condicao in condicoes',
                                        :key='condicao.id',
                                        :label='condicao.label',
                                        :value='condicao.value'
                                    )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.provincia")',
                                prop='provincia'
                            )
                                el-select#provincia(
                                    v-model='formEdicaoContrato.provincia',
                                    v-loading='carregandoNivelUm',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='provincia in provincias',
                                        :key='provincia.id',
                                        :label='provincia.label',
                                        :value='provincia.id'
                                    )
                        .row-4
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.departamento")',
                                prop='departamento'
                            )
                                el-select#departamento(
                                    v-model='formEdicaoContrato.departamento',
                                    v-loading='carregandoNivelDois',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='departamento in departamentos',
                                        :key='departamento.id',
                                        :label='departamento.label',
                                        :value='departamento.id'
                                    )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.origem")',
                                prop='localidade'
                            )
                                el-select#localidade(
                                    v-model='formEdicaoContrato.localidade',
                                    v-loading='carregandoNivelTres',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='localidade in localidades',
                                        :key='localidade.id',
                                        :label='localidade.label',
                                        :value='localidade.id'
                                    )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.estrutura")',
                                prop='estrutura'
                            )
                                el-input#estrutura(
                                    v-model='formEdicaoContrato.estrutura',
                                    :placeholder='$t("mensagens.comuns.placeholder")'
                                )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.volumeContratado")',
                                prop='volumeContratado'
                            )
                                el-input#volumeContratado(
                                    v-model='formEdicaoContrato.volumeContratado',
                                    :placeholder='$t("mensagens.comuns.placeholder")'
                                )
                        .row-add
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.idPlantaEntregaBunge")',
                                prop='idPlantaEntregaBunge'
                            )
                                el-select#idPlantaEntregaBunge0(
                                    v-model='formEdicaoContrato.idPlantaEntregaBunge',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='destino in destinos',
                                        v-loading='carregandoPlantas',
                                        :key='destino.id',
                                        :label='destino.nome',
                                        :value='destino.id'
                                    )
                            el-form-item(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.condicaoFrete")',
                                prop='condicaoFrete'
                            )
                                el-select#condicaoFrete(
                                    v-model='formEdicaoContrato.condicaoFrete',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='frete in fretes',
                                        :key='frete.id',
                                        :id='frete.id',
                                        :label='frete.label',
                                        :value='frete.value'
                                    )
                            el-button.editarTerritorio(
                                type='primary',
                                :disabled='editandoContrato',
                                @click='salvarEdicao(formEdicaoContrato)'
                            )
                                | {{ $t('mensagens.comuns.salvar') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import LocalidadeService from '@/services/LocalidadeService';
import SucursaleService from '@/services/SucursaleService';
import { validateCuit } from '@/utils/validations/cuit';

export default {
    name: 'VisualizarContratoOriginacaoEmpresa',
    components: { BaseHeader },
    data() {
        const validarNumeroContrato = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            if (value.toString().length !== 10) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroContrato'
                        )
                    )
                );
                return;
            }

            const apenasNumeros = /^\d*$/;
            if (!apenasNumeros.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoCaracterNumeroContrato'
                        )
                    )
                );
                return;
            }

            callback();
        };

        const validarVolumeContratado = (rule, value, callback) => {
            // Verifica se o campo está vazio
            if (value === '') {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            // Não permite valores com ponto (.)
            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorComPontos'
                        )
                    )
                );
                return;
            }

            // Não permite mais de uma vírgula e vírgulas no início ou fim do valor
            const regexMaisDeUmaVirgula = /.*,.*,.*/;
            if (
                regexMaisDeUmaVirgula.test(value) ||
                value.startsWith(',') ||
                value.endsWith(',')
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                        )
                    )
                );
                return;
            }

            // Permite apenas números e uma única vírgula para decimais
            const regexNumeroVirgula = /^\d+(,\d{1,2})?$/;
            if (!regexNumeroVirgula.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                        )
                    )
                );
                return;
            }

            // Converte a string para número
            const valorNumerico = parseFloat(value.replace(',', '.'));
            if (valorNumerico <= 0) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorZerado'
                        )
                    )
                );
                return;
            }

            // Se todas as validações passarem
            callback();
        };

        const validationDocument = (_, value, callback) => {
            if (!validateCuit(value)) {
                callback(this.$t('mensagens.pessoas.cuitErro'));
            } else {
                callback();
            }
        };

        return {
            formEdicaoContrato: {
                id: '',
                numeroContrato: '',
                corredor: '',
                sucursal: '',
                vendedor: '',
                cultura: '',
                anoAfip: '',
                dataContrato: '',
                dataEntrega: '',
                cuitVendedor: '',
                condicaoCliente: '',
                provincia: '',
                departamento: '',
                localidade: '',
                estrutura: '',
                volumeContratado: '',
                idPlantaEntregaBunge: '',
                condicaoFrete: ''
            },

            formEdicaoContratoRegras: {
                numeroContrato: [
                    {
                        required: true,
                        validator: validarNumeroContrato,
                        trigger: 'blur'
                    }
                ],
                corredor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                sucursal: [
                    {
                        required: false,
                        trigger: 'change'
                    }
                ],
                vendedor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                cultura: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                anoAfip: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                dataContrato: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                dataEntrega: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                cuitVendedor: [
                    {
                        required: true,
                        validator: validationDocument,
                        trigger: 'blur'
                    }
                ],
                condicaoCliente: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                provincia: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                departamento: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                localidade: [
                    {
                        required: false,
                        trigger: 'change'
                    }
                ],
                estrutura: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                volumeContratado: [
                    {
                        required: true,
                        validator: validarVolumeContratado,
                        trigger: 'blur'
                    }
                ],
                idPlantaEntregaBunge: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                condicaoFrete: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ]
            },
            fornecedores: [],
            provincias: [],
            departamentos: [],
            localidades: [],
            culturas: [],
            safras: [],
            condicoes: [
                {
                    id: 1,
                    value: 'acopiador',
                    label: this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.coletor'
                    )
                },
                {
                    id: 2,
                    value: 'cosignatario',
                    label: this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.destinatario'
                    )
                },
                {
                    id: 3,
                    value: 'produtor',
                    label: this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.produtor'
                    )
                }
            ],
            fretes: [
                { id: 1, value: 'CIF', label: 'CIF' },
                { id: 2, value: 'FOB', label: 'FOB' }
            ],
            destinos: [],
            sucursais: [],
            carregandoNivelUm: false,
            carregandoNivelDois: false,
            carregandoNivelTres: false,
            carregandoSafras: false,
            carregandoCulturas: false,
            carregandoFornecedores: false,
            carregandoPlantas: false,
            carregandoSucursais: false,
            editandoContrato: false,
            carregando: false,

            pickerOptionsDataContrato: {
                disabledDate: date => date > new Date()
            },
            sucursalBloqueadaPorDistribuicao: false
        };
    },
    async mounted() {
        this.carregando = true;

        try {
            // Carrega todas as opções de selects
            await Promise.all([
                this.listarLocalidadeNivelUm(),
                this.buscarFornecedores(),
                this.plantasEntregaBunge(),
                this.buscarCulturas(),
                this.buscarSafras()
            ]);

            // Busca os dados do contrato apenas após os selects estarem preenchidos
            await this.buscarDados();
        } finally {
            this.carregando = false;
        }
    },
    watch: {
        'formEdicaoContrato.provincia'(newVal) {
            if (newVal) {
                this.listarLocalidadeNivelDois(newVal);
                if (!this.carregando) {
                    this.resetFieldIfNotEmpty('departamento');
                    this.resetFieldIfNotEmpty('localidade');
                }
            }
        },
        'formEdicaoContrato.departamento'(newVal) {
            if (newVal) {
                this.listarLocalidadeNivelQuatro(newVal);
                if (!this.carregando) {
                    this.resetFieldIfNotEmpty('localidade');
                }
            }
        },
        'formEdicaoContrato.corredor'(newVal) {
            if (newVal && !this.sucursalBloqueadaPorDistribuicao) {
                this.listarSucursais(newVal);

                if (!this.carregando) {
                    this.resetFieldIfNotEmpty('sucursal');
                }
            }
        }
    },
    methods: {
        async buscarDados() {
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.buscarContratoOriginacaoAR(
                        this.$route.params.id
                    );

                const dados = data.dadosContratoOriginacao;

                const sucursaisContrato = Array.isArray(data.sucursal)
                    ? data.sucursal
                    : data.sucursal
                        ? [data.sucursal]
                        : [];

                let sucursalSelecionada = '';

                this.sucursalBloqueadaPorDistribuicao = false;

                if (sucursaisContrato.length === 1) {
                    sucursalSelecionada = sucursaisContrato[0].id;
                }

                if (sucursaisContrato.length > 1) {
                    this.sucursalBloqueadaPorDistribuicao = true;
                    sucursalSelecionada = 'CONTRATO_DISTRIBUIDO';

                    this.sucursais = [
                        {
                            id: 'CONTRATO_DISTRIBUIDO',
                            label: this.$t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.contratoJaDistribuido')
                        }
                    ];
                }

                this.formEdicaoContrato = {
                    id: dados.id,
                    numeroContrato: dados.numeroContrato,
                    corredor: dados.fornecedorParceiroId
                        ? parseInt(dados.fornecedorParceiroId)
                        : null,
                    sucursal: sucursalSelecionada,
                    cuitVendedor: dados.cuitVendedor,
                    vendedor: dados.nomeVendedor,
                    cultura: dados.idMaterial
                        ? parseInt(dados.idMaterial)
                        : null,
                    anoAfip: dados.idSafra ? parseInt(dados.idSafra) : null,
                    dataContrato: new Date(dados.dataContrato),
                    dataEntrega: new Date(dados.dataPrevistaEntrega),
                    provincia: dados.localidadeNivelUmId,
                    departamento: dados.localidadeNivelDoisId,
                    localidade: dados.localidadeNivelQuatroId,
                    volumeContratado: dados.volumeContratado
                        .toString()
                        .replace('.', ''),
                    condicaoCliente: dados.condicaoCliente,
                    estrutura: dados.estructuraComercial,
                    condicaoFrete: dados.condicaoFrete,
                    idPlantaEntregaBunge: dados.plantaEntregaBungeId
                };
            } catch (error) {
                this.$notify.error({
                    message:
                        error.response?.data?.message ||
                        error.message ||
                        this.$t('mensagens.sistema.erroInformacoes')
                });
                this.$router.push({ path: '/rastreabilidade/empresa' });
            }
        },

        salvarEdicao() {
            this.$refs['formEdicaoContratoRef'].validate(async valid => {
                if (valid) {
                    this.editandoContrato = true;
                    ContratoOriginacaoServiceEmpresa.editarContratoAR({
                        id: this.formEdicaoContrato.id,
                        numeroContrato: this.formEdicaoContrato.numeroContrato,
                        contratoOriginacaoFornecedorParceiro: {
                            id: this.formEdicaoContrato.corredor
                        },
                        sucursal: this.sucursalBloqueadaPorDistribuicao
                            ? null
                            : this.formEdicaoContrato.sucursal,
                        cuitVendedor: this.formEdicaoContrato.cuitVendedor,
                        nomeVendedor: this.formEdicaoContrato.vendedor,
                        idMaterial: this.formEdicaoContrato.cultura,
                        idSafra: this.formEdicaoContrato.anoAfip,
                        dataContrato:
                            this.formEdicaoContrato.dataContrato.getTime(),
                        dataPrevistaEntrega:
                            this.formEdicaoContrato.dataEntrega.getTime(),
                        idDepartamento: this.formEdicaoContrato.departamento,
                        idLocalidade: this.formEdicaoContrato.localidade,
                        volumeContratado: parseFloat(
                            this.formEdicaoContrato.volumeContratado.replace(
                                ',',
                                '.'
                            )
                        ),
                        idPlantaEntregaBunge:
                            this.formEdicaoContrato.idPlantaEntregaBunge,
                        condicaoCliente:
                            this.formEdicaoContrato.condicaoCliente,
                        estructuraComercial: this.formEdicaoContrato.estrutura,
                        condicaoFrete: this.formEdicaoContrato.condicaoFrete
                    })
                        .then(() => {
                            this.$notify.success(
                                this.$t(
                                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contrato'
                                ) +
                                    ' ' +
                                    this.formEdicaoContrato.numeroContrato +
                                    ' ' +
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contratoAlterado'
                                    )
                            );
                            this.redirecionar();
                        })
                        .catch(error => {
                            if (
                                error.response.status === 405 ||
                                error.response.status === 400
                            ) {
                                this.$notify.error({
                                    message: error.response.data.message
                                });
                            } else {
                                this.$notify.error(
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.erroEditarContrato'
                                    )
                                );
                            }
                        });
                } else {
                    this.$notify.warning(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoTodosCampos'
                        )
                    );
                    return false;
                }
            });
        },
        async buscarFornecedores() {
            try {
                this.carregandoFornecedores = true;
                const { data } =
                    await ContratoOriginacaoService.buscarBpClientes();
                this.fornecedores = data;

                this.carregandoFornecedores = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarFornecedor'
                    )
                );
            }
        },

        async buscarCulturas() {
            try {
                this.carregandoCulturas = true;

                const { data } =
                    await ContratoOriginacaoService.buscarCulturas();
                this.culturas = data;

                this.carregandoCulturas = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCultura'
                    )
                );
            }
        },

        async buscarSafras() {
            try {
                this.carregandoSafras = true;
                const { data } = await ContratoOriginacaoService.buscarSafras();

                this.safras = data;
                this.carregandoSafras = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSafra'
                    )
                );
            }
        },

        async listarSucursais(id) {
            try {
                this.carregandoSucursais = true;
                const { data } =
                    await SucursaleService.buscarSucursaisPorRevenda(id);
                const dataFormat = data.sucursais
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));
                this.sucursais = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.sistema.erroInformacoes')
                });
            } finally {
                this.carregandoSucursais = false;
            }
        },

        async plantasEntregaBunge() {
            try {
                this.carregandoPlantas = true;
                const response =
                    await ContratoOriginacaoServiceEmpresa.plantasEntregaBunge();
                const { data } = response;

                this.destinos = data;
                this.carregandoPlantas = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarEstados'
                    )
                );
            }
        },

        async listarLocalidadeNivelUm() {
            try {
                this.carregandoNivelUm = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();

                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));

                this.provincias = dataFormat;
                this.carregandoNivelUm = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelUm'
                    )
                });
            }
        },

        async listarLocalidadeNivelDois(id) {
            try {
                this.carregandoNivelDois = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(id);
                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));
                this.departamentos = dataFormat;
                this.carregandoNivelDois = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },

        async listarLocalidadeNivelTres(id) {
            try {
                this.carregandoNivelTres = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelTres(id);
                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));

                this.localidades = dataFormat;
                this.carregandoNivelTres = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },

        async listarLocalidadeNivelQuatro(id) {
            try {
                this.carregandoNivelTres = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelQuatro(id);
                this.localidades = [];
                if (data) {
                    const dataFormat = data
                        .map(item => {
                            return { label: item.nome, id: item.id };
                        })
                        .sort((a, b) => this.orderName(a, b));

                    this.localidades = dataFormat;
                }

                this.carregandoNivelTres = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },

        formatarData(data) {
            const adjustedDate = new Date(data.getTime() - 3 * 60 * 60 * 1000);
            const formattedDate = adjustedDate.toISOString().slice(0, -5);
            return formattedDate;
        },

        resetFieldIfNotEmpty(field) {
            if (this.formEdicaoContrato[field]) {
                this.formEdicaoContrato[field] = '';
            }
        },

        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        },
        redirecionar() {
            this.editandoContrato = false;
            this.$router.push({ path: '/rastreabilidade/empresa' });
        }
    }
};
</script>

<style lang="scss">
#editar-contrato-originacao {
    .editar-contrato-originacao__body {
        padding: 20px 33px 20px 20px;
        overflow-y: auto;
    }
    .el-form-item__content {
        line-height: 40px;
        position: relative;
        font-size: 14px;
        width: 100%;
    }
    .editar-contrato-originacao__card {
        gap: 10px;
        display: grid;
        h1 {
            font-size: 16px;
            font-weight: bold;
            line-height: 19px;
            margin-top: 15px;
        }

        .el-card {
            border-radius: 15px;
        }

        .el-collapse-item {
            border-radius: 10px;
            overflow: hidden;
        }

        .el-collapse-item__content {
            padding: 0px;
        }

        .el-form-item {
            padding: 0 4px;
        }

        .el-select,
        .el-input,
        .el-date-picker,
        .el-button {
            width: 100%;
        }

        .row-3 {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 14px;
        }

        .row-4 {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            gap: 14px;
        }

        .row-add {
            display: grid;
            grid-template-columns: 1.5fr 1.5fr 0.75fr;
            gap: 14px;
        }

        .editarTerritorio {
            height: fit-content;
            margin: auto 0 8px 0;
            span i {
                color: white !important;
                margin-right: 8px;
            }
        }

        .el-form-item.is-required:not(.is-no-asterisk)
            > .el-form-item__label::before,
        .el-form-item.is-required:not(.is-no-asterisk)
            .el-form-item__label-wrap
            > .el-form-item__label:before {
            content: none !important;
            margin-right: 0px !important;
        }

        .el-form-item.is-required:not(.is-no-asterisk)
            > .el-form-item__label:after,
        .el-form-item.is-required:not(.is-no-asterisk)
            .el-form-item__label-wrap
            > .el-form-item__label:after {
            content: '*';
            color: #f56c6c;
            margin-left: 4px;
        }
    }
    .el-form-item.col-3.botao {
        display: flex;
        align-items: flex-end;
        justify-content: left;
    }
}
</style>
